export default function TSeriesUtilizationController(
  $scope,
  TSeriesService,
  $q,
  $timeout,
  $state,
  gettextCatalog
) {
  'ngInject';

  // variable
  var self = this;
  $scope.utilizations = [];
  $scope.utilizationcsvexportData = [];
  $scope.errorFlag = false;
  $scope.errorText = gettextCatalog.getString('Oops! Somthing went wrong.');
  var timer = null;

  // column colors
  var colorArray = ['#FF0F00', '#FF6600', '#04D215', '#F8FF01', '#0D8ECF', '#2A0CD0', '#CD0D74'];

  self.init = function () {
    $scope.loading = true;
    $scope.errorFlag = false;

    TSeriesService.getUtilizationSummary()
      .then(
        function (response) {
          $scope.utilizations = [];
          var color_index = 0;
          if (response.data) {
            for (var i = 0; i < response.data.length; i++) {
              if (color_index == colorArray.length) {
                color_index = 0;
              }
              var name = response.data[i].name ? response.data[i].name : response.data[i].esn;
              var model = response.data[i].model ? response.data[i].model : '';
              var make = response.data[i].make ? response.data[i].make : '';

              $scope.utilizations.push({
                name: name,
                make_model: make + ' ' + model,
                equipid: response.data[i].equipmentId,
                model: model,
                make: make,
                utilize: response.data[i].today,
                color: colorArray[color_index++]
              });
            }
          }

          self.getChartready();
        },
        function (error) {
          $scope.errorFlag = true;
          $scope.errorText = gettextCatalog.getString('Oops! Somthing went wrong.');
        }
      )
      .finally(function () {
        $scope.loading = false;
      });

    TSeriesService.getUtilizationDetail().then(
      function (response) {
        var utilizationDetails = response.data || [];
        var csvData = self.getCsvData(utilizationDetails);
        $scope.utilizationcsvexportData = csvData;
      },
      function (error) {
        $scope.utilizationcsvexportData = [];
      }
    );

    // run refresh
    timer = $timeout(function () {
      self.init();
    }, 60000); // 1 min
  };

  // return utilization details for reports
  $scope.getUtilizationDetail = function () {
    // use defeerd object so download will wait till callback done
    var deferred = $q.defer();
    var csvData = [];
    TSeriesService.getUtilizationDetail().then(
      function (response) {
        var utilizationDetails = response.data;
        csvData = self.getCsvData(utilizationDetails);
        deferred.resolve(csvData);
      },
      function (error) {
        deferred.reject();
      }
    );
    return deferred.promise;
  };

  // return custom tooltip text for the gragh
  function adjustBalloonText(graphDataItem, graph) {
    return (
      graphDataItem.dataContext.name +
      '</br>' +
      graphDataItem.dataContext.make +
      ' ' +
      graphDataItem.dataContext.model +
      '</br><b>' +
      graphDataItem.dataContext.utilize +
      '</b>'
    );
  }

  // make chart
  self.getChartready = function () {
    var chart = new AmCharts.makeChart('utilizationChart', {
      theme: 'light',
      type: 'serial',
      startDuration: 0,
      dataProvider: $scope.utilizations,
      graphs: [{
        balloonText: '[[category]]</br><b>[[value]]</b>',
        fillAlphas: 1,
        lineAlpha: 0.1,
        type: 'column',
        colorField: 'color',
        balloonFunction: adjustBalloonText,
        valueField: 'utilize'
      }],
      valueAxes: [{
        axisAlpha: 0,
        position: 'left',
        gridAlpha: 0
      }],
      depth3D: 0,
      chartCursor: {
        categoryBalloonEnabled: false,
        cursorAlpha: 0,
        zoomable: false
      },
      categoryField: 'name',
      categoryAxis: {
        gridPosition: 'start',
        axisAlpha: 0,
        gridAlpha: 0,
        labelRotation: 30
      },
      export: {
        enabled: false
      },
      listeners: [{
        event: 'clickGraphItem',
        method: function (event) {
          if (event.item.dataContext.equipid) {
            $state.go('equipment.detail.overview', {
              equipmentId: event.item.dataContext.equipid
            });
          }
        }
      }]
    });
  };

  $scope.getCsvFileName = function () {
    var fileName = gettextCatalog.getString('T_series_Utilization_');
    var d = new Date();
    var date =
      d.getFullYear() + '_' + (d.getMonth() + 1) + '_' + d.getDate() + '_' + d.getHours() + '-' + d.getMinutes();

    fileName += date;
    return fileName + '.csv';
  };

  self.getCsvData = function (utilizationDetailList) {
    var CsvData = [];

    var headers = {
      ESN: 'ESN',
      Name: 'Name',
      Make: 'Make',
      Model: 'Model',
      Today: 'Today (Hours)',
      Lifetime: 'Life Time (Hours)'
    };

    CsvData.push(headers);

    for (var i = 0; i < utilizationDetailList.length; i++) {
      var esn = utilizationDetailList[i].esn;
      var name = utilizationDetailList[i].name;
      var make = utilizationDetailList[i].make;
      var model = utilizationDetailList[i].model;
      var today = utilizationDetailList[i].today;
      var lifetime = utilizationDetailList[i].lifetime;

      var csvObject = {
        ESN: esn,
        Name: name,
        Make: make,
        Model: model,
        Today: typeof today === 'number' ? today.toFixed(2) : today,
        lifetime: typeof lifetime === 'number' ? lifetime.toFixed(2) : lifetime
      };

      CsvData.push(csvObject);
    }
    return CsvData;
  };

  self.init();

  // cancel the timer when navigate away.
  $scope.$on('$destroy', function () {
    if (timer) {
      $timeout.cancel(timer);
    }
  });
}